import CryptoJS from 'crypto-js';
import { jwtDecode } from 'jwt-decode';

function hashSignature(signature) {
  try {
    const hash = CryptoJS.MD5(signature).toString(CryptoJS.enc.Hex);

    // Slice the first 16 characters
    const hashedSignature = hash.slice(0, 16);

    return hashedSignature;
    // return hashedSignature;
  } catch (error) {
    console.error('Hashing error:', error);
    throw error;
  }
}

export const decryptData = (data, token) => {
  try {
    if (!token && token === undefined) {
      return;
    }
    const parts = token.split('.');
    const user = jwtDecode(token);
    if (!user || !user.key) {
      return;
    }
    const secretKey = CryptoJS.MD5(user.key).toString(CryptoJS.enc.Hex).slice(0, 32);
    const secretIv = parts[2];

    const hashed = CryptoJS.MD5(hashSignature(secretIv))
      .toString(CryptoJS.enc.Hex)
      .slice(0, 16);

    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Hex.parse(data.encrypted), // Parse hex back to WordArray
    });
    const KEY = CryptoJS.enc.Utf8.parse(secretKey); // Convert key to WordArray
    const IV = CryptoJS.enc.Utf8.parse(hashed); // Convert IV to WordArray
    const ALGORITHM = CryptoJS.mode.CBC; // Set AES mode
    const cipher = CryptoJS.AES.decrypt(cipherParams, KEY, {
      iv: IV,
      mode: ALGORITHM,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedText = cipher.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (err) {
    console.error('Decryption failed:', err); // Handle any errors during decryption
  }
};



